import { Modal } from "@/components/modal/modal";
import { ExternalLink } from "ui/Link";
import { Spinner } from "@/components/ui/spinner";
import { NeedHelpButton } from "features/social-account-connect/components/need-help-button";
import { PlatformTypes } from "features/post";

export function WaitForReview({ className }: { className?: string }) {
  return (
    <Modal.Body className={className}>
      <h5>We're checking your account</h5>
      <div className="flex justify-center py-4">
        <Spinner size="lg" />
      </div>
      <p>
        {" "}
        We have to check every account to make sure it meets{" "}
        <ExternalLink href="https://help.instagram.com/477434105621119">
          Instagram's community guidelines.
        </ExternalLink>
      </p>
      <p>It shouldn't take more than 5 minutes.</p>
      <div className="flex justify-end">
        <NeedHelpButton
          platform={PlatformTypes.instagram}
          chatQuery="accounts"
        />
      </div>
    </Modal.Body>
  );
}
